export default __webpack_public_path__ + "static/media/intro_03.0c7c6435.png";